import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';
import { initTelemetry } from './lib/telemetry';
import { TOOL, TOOL_ICON, TOOL_NAME } from './lib/tool';

// Error reports (error-alerts-silent): off unless a Sentry DSN is built in.
void initTelemetry();

// 2026-06-13 — belt-and-braces dark mode. The class also lives on
// <html> in index.html, but Vite dev sometimes serves a stale HTML
// shell (and any static-server setup can serve a stale build).
// Applying the class from JS too guarantees it's present in every
// environment. Same pattern shipped on the FP yesterday.
if (typeof document !== 'undefined') {
  document.documentElement.classList.add('dark');
  document.documentElement.style.colorScheme = 'dark';
}

// The split (Design's sketch, Nino's go 27 Oct): the browser tab shows this tool's name and tile.
if (typeof document !== 'undefined') {
  document.title = TOOL_NAME[TOOL];
  document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', TOOL_ICON[TOOL]);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
